import React, { useMemo } from 'react'
import classNames from 'classnames'
import { STRENGTH_SCALE_MAX } from '@/shared/lib/strengthScale.const'
import cls from './strength-scale.module.scss'

/**
 * Шкала крепости из точек: `filled` штук закрашены, остальные — серые.
 * @param {{filled: number, max?: number, className?: string}} props
 * @returns {JSX.Element}
 */
export const StrengthScale = ({ filled, max = STRENGTH_SCALE_MAX, className }) => {
  const dots = useMemo(() => Array(max).fill(1), [max])

  return (
    <div className={classNames(cls.scale, className)}>
      {dots.map((_, index) => (
        <div key={index} className={classNames(cls.dot, { [cls.filled]: index < filled })} />
      ))}
    </div>
  )
}
